import ArchiveFilter from './components/ArchiveFilter/ArchiveFilter';
import singleContentsMvSwiper from './components/singleContentsMvSwiper';
import singleSwiper from './components/singleSwiper';
import SwiperNearSpots from './components/nearSpotsSwiper';

// ArchiveFilter
//
// アーカイブ一覧ページにおける絞り込みフォーム要素パーツ
if (document.querySelector('[data-role="archive-filter"]')) {
  if (document.querySelector('.archive-filter-area-map')) {
    // eslint-disable-next-line no-new
    new ArchiveFilter();
  } else {
    // eslint-disable-next-line no-new
    new ArchiveFilter({ disableAreaMapMode: true });
  }
}

// header関連
if (document.querySelector('.global-header') !== null) {
  document.querySelector('.js-menu-toggle').addEventListener('click', function () {
    if (this.classList.contains('is-menu-open')) {
      this.classList.remove('is-menu-open');
      this.setAttribute('aria-expanded', false);
      this.setAttribute('aria-label', 'メニュー');
      document.querySelector('body').classList.remove('is-hidden');
    } else {
      this.classList.add('is-menu-open');
      this.setAttribute('aria-expanded', true);
      this.setAttribute('aria-label', '閉じる');
      document.querySelector('body').classList.add('is-hidden');
    }
  });

  document.querySelector('.js-language-toggle').addEventListener('click', function () {
    if (this.classList.contains('is-language-open')) {
      this.classList.remove('is-language-open');
      this.setAttribute('aria-expanded', false);
      document.querySelector('.global-sub-menu-language-list').classList.remove('is-active');
    } else {
      this.classList.add('is-language-open');
      this.setAttribute('aria-expanded', true);
      document.querySelector('.global-sub-menu-language-list').classList.add('is-active');
    }
  });
  document.querySelector('.js-search-toggle').addEventListener('click', function () {
    if (this.classList.contains('is-search-open')) {
      this.classList.remove('is-search-open');
      this.setAttribute('aria-expanded', false);
      document.querySelector('.global-sub-menu-search__contents').classList.remove('is-active');
    } else {
      this.classList.add('is-search-open');
      this.setAttribute('aria-expanded', true);
      document.querySelector('.global-sub-menu-search__contents').classList.add('is-active');
    }
  });
  document.querySelector('.global-sub-menu-search__contents__btn-close').addEventListener('click', function () {
    document.querySelector('.js-search-toggle').classList.remove('is-search-open');
    document.querySelector('.js-search-toggle').setAttribute('aria-expanded', false);
    document.querySelector('.global-sub-menu-search__contents').classList.remove('is-active');
  });
}

// tab
const cmnTabElms = document.querySelectorAll('[data-role="cmn-tab"]');
if (cmnTabElms.length) {
  cmnTabElms.forEach((elm) => {
    const tabBtnsArea = elm.querySelector('[role="tablist"]');
    tabBtnsArea.addEventListener('click', (ev) => {
      const tabBtnElm = ev.target;
      if (tabBtnElm.hasAttribute('data-target')) {
        let tabTarget;
        let tabCurrentTarget = tabBtnElm.getAttribute('data-target');

        // ボタン切り替え
        const tabBtns = elm.querySelectorAll('[data-role="tabbtn"]');
        tabBtns.forEach((tabBtn) => {
          tabTarget = tabBtn.getAttribute('data-target');
          if (tabTarget === tabCurrentTarget) {
            tabBtn.classList.add('is-active');
            tabBtn.ariaSelected = true;
            tabBtn.removeAttribute('tabindex');
          } else {
            tabBtn.classList.remove('is-active');
            tabBtn.ariaSelected = false;
            tabBtn.setAttribute('tabindex', '-1');
          }
        });

        // パネル切り替え
        const tabContentsElm = elm.querySelectorAll('[role="tabpanel"]');
        tabContentsElm.forEach((tabContents) => {
          tabTarget = tabContents.getAttribute('id');
          if (tabTarget === tabCurrentTarget) {
            tabContents.classList.add('is-active');
          } else {
            tabContents.classList.remove('is-active');
          }
        });
      }
    });
  });
}

// 詳細ページMV用swiper
const singleContentsMvSwiperElms = document.querySelectorAll("[data-role='single-contents-mv-swiper']");
if (singleContentsMvSwiperElms.length) {
  singleContentsMvSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new singleContentsMvSwiper({ elm });
  });
}

// 画像1枚のみ表示swiper
const singleSwiperElms = document.querySelectorAll("[data-role='single-swiper']");
if (singleSwiperElms.length) {
  singleSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new singleSwiper({ elm });
  });
}

// 近くのスポット用swiper
const nearSpotsSwiperElms = document.querySelectorAll("[data-role='near-spots-swiper']");
if (nearSpotsSwiperElms.length) {
  nearSpotsSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new SwiperNearSpots({ elm });
  });
}
